module.exports = __webpack_public_path__ + "static/media/magaluLogo.da2e3b84.png";